export interface IQuoteAddress {
  city: string | null;
  state: string | null;
  zip_code: string | null;
}

export const createDefaultQuoteAddress = (): IQuoteAddress => ({
  city: null,
  state: null,
  zip_code: null,
});

export const prettyAddress: Record<keyof IQuoteAddress, string> = {
  city: 'City',
  state: 'State',
  zip_code: 'Zip Code',
};
